/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_BalconyInputs */

const cs_enum_balcony = /** @type {(inputs: Enum_BalconyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balkon`)
};

const en_enum_balcony = /** @type {(inputs: Enum_BalconyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balcony`)
};

/**
* | output |
* | --- |
* | "Balcony" |
*
* @param {Enum_BalconyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_balcony = /** @type {((inputs?: Enum_BalconyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_BalconyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_balcony(inputs)
	return cs_enum_balcony(inputs)
});